import { makeSelectedEvent } from 'app/pages/TicketSalePage/slice/selectors';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import ApplyCode from './ApplyCode';
import IdMeSection from './IdMeSection';
import { selectVendorFeatures } from 'store/vendorSlice/selectors';

const ApplyCodeSection: React.FC<{}> = () => {
  const { t } = useTranslation();
  const { hasIdMeImplementation } = useSelector(selectVendorFeatures);
  const { hasVoucher, numberOfPublicTicketTypes, numberOfPrivateTicketTypes } =
    useSelector(makeSelectedEvent);

  const [selectedTab, setSelectedTab] = useState<'applyCode' | 'idme'>(
    'applyCode',
  );

  const hasPrivateTickets = numberOfPrivateTicketTypes > 0;
  const isPrivateEvent =
    numberOfPublicTicketTypes === 0 && numberOfPrivateTicketTypes > 0;

  if (!hasVoucher && !hasPrivateTickets) return null;

  return (
    <>
      {isPrivateEvent ? (
        <div className="mb-[16px]">
          <h2 className="text-neutral-1000">
            {t('ticketSale.privateEventTitle')}
          </h2>
          <p className="p2-regular text-neutral-800 mt-[2px]">
            {t('ticketSale.privateEventSubtitle')}
          </p>
        </div>
      ) : null}
      {hasIdMeImplementation ? (
        <div className="horizontal-tab-items flex mb-4">
          <div
            className={`tab-item rounded-l-md ${
              selectedTab === 'applyCode' && 'checked'
            }`}
            onClick={() => {
              setSelectedTab('applyCode');
            }}
          >
            <p className="p2-semibold">Voucher Code</p>
          </div>
          <div
            className={`tab-item rounded-r-md ${
              selectedTab === 'idme' && 'checked'
            }`}
            onClick={() => setSelectedTab('idme')}
          >
            <p className="p2-semibold"> Military & First Responders</p>
          </div>
        </div>
      ) : null}
      {selectedTab === 'applyCode' ? <ApplyCode /> : <IdMeSection />}
    </>
  );
};

export default ApplyCodeSection;
